import propTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getOnboardingRedirectPath } from '../../utils/onboardingRedirect';

function ProtectedRoute({ Component }) {
  const isLoggedIn = useSelector((state) => state.auth.login);
  const UsersProfile = useSelector((state) => state?.auth.user);
  const MeProfile = useSelector((state) => state?.auth.me);
  const isSwitched = useSelector((state) => state?.user?.isSwitched);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  const role = UsersProfile?.role;
  // Prefer /merchant/me onboarding_steps; avoid mixing with stale user when me is loaded
  const onboarding =
    MeProfile?.onboarding_steps != null ? MeProfile.onboarding_steps : UsersProfile?.onboarding_steps ?? null;
  const currentStep =
    onboarding?.current_step ?? MeProfile?.current_step ?? UsersProfile?.current_step;

  // Keep onboarding redirect for direct merchant logins.
  // When superadmin/staff switches into merchant (isSwitched=true), allow /profile access.
  if (role === 'merchant' && isSwitched !== true && onboarding && onboarding?.all_completed === false && currentStep !== 6) {
    const path = getOnboardingRedirectPath(onboarding);
    if (path) {
      return <Navigate to={path} replace />;
    }
    // e.g. pending_step.redirect_page is "dashboard" — no mapped onboarding URL; allow /profile etc.
    return <Component />;
  }

  return <Component />;
}

ProtectedRoute.propTypes = {
  Component: propTypes.elementType.isRequired,
};

export default ProtectedRoute;
